export default {
  scene: {
    background: 0xffbc8d,
    shadow: 0xee9559,
    fog: {
      color: 0xffbc8d,
      near: 50,
      far: 500
    }
  },
  camera: {
    x: 3,
    y: 1,
    z: 1
  },
  environment: {
    path: '/models/environments/intro.glb',
    rotation: Math.PI / 2,
    position: {
      x: 15,
      y: -10.1,
      z: 0
    }
  },
  character: {
    path: '/models/characters/wouter/animated.glb',
    rotation: Math.PI / 2,
    position: {
      x: -5,
      y: -10,
      z: 0
    }
  },
  speed: 3
}
